import React from 'react'

const PublicLayout = props => (
  <div>
    { props.children }
  </div>
)

export default PublicLayout
